import { Trans } from '@lingui/react/macro';

import { RadioItem, RadioItemGroup } from '@/design_system/Radio/RadioItem/RadioItem';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { useQuestionTypeOptions } from '@/routes/Settings/ConditionForms/ConditionFormEditor';

import { type ConditionFormQuestion } from '../ConditionQuestion';

export const QuestionTypeRadioGroup = ({
  type,
  onChange,
}: {
  type: ConditionFormQuestion['type'];
  onChange: (type: ConditionFormQuestion['type']) => void;
}) => {
  const questionTypeOptions = useQuestionTypeOptions();

  return (
    <Stack gap="0.25rem">
      <Paragraph weight="medium">
        <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.type">
          Question type:
        </Trans>
      </Paragraph>
      <RadioItemGroup name="question-type" value={type} onChange={onChange}>
        {questionTypeOptions.map((option) => (
          <RadioItem key={option.value} value={option.value} ariaLabel={option.label}>
            {option.label}
          </RadioItem>
        ))}
      </RadioItemGroup>
    </Stack>
  );
};
